import React, { useEffect } from 'react'
import { Checkbox, Tooltip } from 'antd'
import _ from "lodash"

const ModalReusedEmbroideryDesignOrders = (props) => {
    const {
        orderTemplate,
        items = [],
        isActionDelete = false,
        className = '',
        selectItems = [],
        setSelectItems,
        allIds,
        ordersErr,
    } = props

    const allSelected = selectItems.length === allIds.length

    const handleToggleAll = (e) => {
        setSelectItems(e.target.checked ? allIds : [])
    }

    const toggleSingleItem = (id) => {
        setSelectItems(prev =>
            prev.includes(id)
                ? prev.filter(x => x !== id)
                : [...prev, id]
        )
    }

    const getOrderErr = (orderErrId) => {
        if (!orderErrId) return null

        const { error } = ordersErr[orderErrId] || {}
        if (!!error) return (
            <Tooltip title={error}>
                <i className="fa fa-exclamation-triangle text-danger cursor-pointer" />
            </Tooltip>
        )
    }

    useEffect(() => {
        setSelectItems(allIds)
    }, [allIds])

    return (
        <div className={`ModalReusedEmbroideryDesignOrders ${!!className ? className : ''}`}>
            <label className='d-flex flex-column mb-3'>
                <i>Danh sách item đc reuse ở trạng thái Đã thiết kế và Chưa in với item (<span className='font-weight-bold'>{orderTemplate}</span>).</i>
                <i>Lựa chọn item muốn {isActionDelete ? 'xóa' : 'update'} thông tin thêu.</i>
            </label>
            <div>
                <div className='mb-2 font-weight-bold' style={{ borderBottom: '1px solid #E9E9E9', paddingBottom: 8 }}>
                    <Checkbox
                        checked={allSelected}
                        indeterminate={false}
                        onChange={handleToggleAll}
                    >
                        Áp dụng cho tất cả item
                    </Checkbox>
                </div>

                <div style={{ maxHeight: isActionDelete ? '400px' : '225px', overflowY: 'auto', marginTop: 10, marginBottom: 10 }}>
                    <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: 12 }}>
                        {items.map(item => {
                            const id = _.get(item, '_id')
                            const isOrigin = _.get(item, 'is_origin', false)
                            const { item_number, barcode_number } = item || {}

                            return (
                                <div key={id} style={{ marginBottom: 8 }}>
                                    <Checkbox
                                        checked={selectItems.includes(id)}
                                        onChange={() => toggleSingleItem(id)}
                                    >
                                        {
                                            isOrigin ?
                                                <Tooltip title="Đơn gốc">
                                                    <span
                                                        className={(!!ordersErr[id] && !!Object.keys(ordersErr[id]).length) ? 'text-danger font-weight-bold' : ''}
                                                        style={{
                                                            color: "#007bff",
                                                            fontWeight: 'bold'
                                                        }}
                                                    >
                                                        #{barcode_number}_{item_number}
                                                    </span>
                                                </Tooltip>
                                                :
                                                <span
                                                    className={(!!ordersErr[id] && !!Object.keys(ordersErr[id]).length) ? 'text-danger font-weight-bold' : ''}
                                                >
                                                    #{barcode_number}_{item_number}
                                                </span>

                                        }
                                    </Checkbox>
                                    {getOrderErr(id)}
                                </div>
                            )
                        })}
                    </div>
                </div>
            </div>
        </div>
    )
}

export default ModalReusedEmbroideryDesignOrders